import { isBrowser, tap } from '@navinc/utils'
import axios from 'axios'

const tapRejection = (fn) => (arg) => {
  fn(arg)
  return Promise.reject(arg)
}

const shouldRedact = () => process.env.CLIENT_LOG_ENVIRONMENT === 'production'

const logResponse = ({ data, status, statusText, headers, config }) => {
  !isBrowser() &&
    console.info(`
[${config.method}] ${config.url}
[headers]: ${JSON.stringify(scrubHeaders(config.headers), null, 2)}
[body]: ${shouldRedact() ? 'REDACTED' : `${JSON.stringify(config.data, null, 2)}`}
->
${`${status}`} ${statusText}
headers: ${JSON.stringify(scrubHeaders(headers), null, 2)}
response: ${shouldRedact() ? 'REDACTED' : `${JSON.stringify(data, null, 2)}`}
`)
}

const logError = (error) => {
  if (isBrowser()) return
  const { response, response: { data, status, headers } = {}, message, name, config } = error
  if (response) {
    console.error(`
  ${name}: ${message}
  [${config.method}] ${config.url}
  [headers]: ${JSON.stringify(scrubHeaders(config.headers), null, 2)}
  [body]: ${shouldRedact() ? 'REDACTED' : `${JSON.stringify(config.data, null, 2)}`}
  ->
  ${`${status}`}
  headers: ${JSON.stringify(scrubHeaders(headers), null, 2)}
  response: ${shouldRedact() ? 'REDACTED' : `${JSON.stringify(data, null, 2)}`}
  `)
  } else {
    return console.error(error.message || error)
  }
}

const removeSignatureFromToken = (token) => token.split('.').slice(0, -1).concat('REDACTED').join('.')

const scrubHeaders = (headers) =>
  Object.fromEntries(
    Object.entries(headers)
      // filter headers we know we want to suppress
      .map(([key, val]) => [key, shouldRedact() && key.match(/api-key/i) ? 'REDACTED' : val])
      .map(([key, val]) => [key, shouldRedact() && key.match(/authorization/i) ? removeSignatureFromToken(val) : val])
  )

export const request = ({ authJWT, body, data = body, headers, method = 'GET', uri = '', url = uri, ...axiosArgs }) =>
  axios({
    method,
    url,
    headers: {
      ...(authJWT && {
        Authorization: `Bearer ${authJWT}`,
        'x-authentication-jwt': authJWT,
      }),
      ...(!isBrowser() && {
        'accept-encoding': 'utf-8',
        'user-agent': 'nav',
      }),
      accept: 'application/json',
      'content-type': 'application/json',
      ...headers,
    },
    data,
    ...axiosArgs,
  })
    .then(tap(logResponse))
    .catch(tapRejection(logError))
